module.exports = __webpack_public_path__ + "img/cl.762a98e9.svg";